import React from 'react'
import { Box } from 'rebass'
import { Text } from 'rebass'
import { Flex } from 'rebass'
import { observer } from 'mobx-react'

// stores
import GameStore from 'App/stores/GameStore'

import PlayerName from 'App/components/playerName/PlayerName'
import Hand from 'App/components/hand/Hand'
import MessageModal from 'App/components/modal/MessageModal'

@observer
class TablePlayerHands extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            modalIsOpen: false
        }

        this.showModal = this.showModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
    }


    showModal () {
        this.setState({
            modalIsOpen: true
        })
    }

    closeModal (err) {
        // Clear error in case we got here that way
        if (err) {
          GameStore.clearError()
        }

        this.setState({
          modalIsOpen: false
        })
      }


  render() {
    return (<>
            <Hand player='north' currentPlayer={this.props.currentPlayer} cardClicked={this.props.cardClicked} clickCloseMarker={this.props.clickCloseMarker} playerHandData={this.props.handData.north} />
            <Hand player='east' currentPlayer={this.props.currentPlayer} cardClicked={this.props.cardClicked} clickCloseMarker={this.props.clickCloseMarker} playerHandData={this.props.handData.east} />
            <Hand player='south' currentPlayer={this.props.currentPlayer} cardClicked={this.props.cardClicked} clickCloseMarker={this.props.clickCloseMarker} playerHandData={this.props.handData.south} />
            <Hand player='west' currentPlayer={this.props.currentPlayer} cardClicked={this.props.cardClicked} clickCloseMarker={this.props.clickCloseMarker} playerHandData={this.props.handData.west} />
            <MessageModal showModal={this.state.modalIsOpen} closeModal={this.closeModal} closeWithOverlay={this.state.modalCloseWithOverlay}>
              {this.state.modalText}
            </MessageModal>
    </>)
}
}
export default TablePlayerHands
